/* Add Email Feb 18, 2023 */
/* Add and use fn_checkPageEnabled Apr 13, 2024 */
<template lang="pug">
	div(id="top-hdr" class="top-hdr" )
		b-dropdown(variant="outline-primary" no-caret toggle-class="btn btn-outline-primary btn-menu" title="Help")
			template(v-slot:button-content )
				fa-icon(icon="question" class="mr-1")
				|Help
			b-card(class="top-hdr-profile")
				div(class="d-flex" v-for ="(h,idx) in d_help")
					span {{idx+1}}.
					a( :href="h.URL" target="_blank") {{h.title}} 
					<span v-if="h.html" v-html="h.html"></span>
		router-link(v-if="d_usrInf.tntAdmn" 
			tag="button" class="btn btn-outline-danger" :to="{path:'#admin'}") 
			fa-icon(icon="user-shield" class="mr-1")
			|Admin
		router-link(id="emaillApp" title="Email" tag="button" class="btn btn-outline-primary btn-menu" :to="{path:'#emailApp'}") 
			fa-icon(icon="envelope" class="mr-1")
			|Email
		b-dropdown(dropdown ref="myPagesDropdown" offset="25" variant="outline-primary" no-caret menu-class="myPages-dropdown" toggle-class="btn-menu" title="My Pages")
			<kt-myPages v-if="m_checkPage('My Pages')" :key="d_componentKey" p_title="My Pages" @close="m_closeMyPagesDropdown" />
			template(v-slot:button-content)
				fa-icon(icon="cog" class="mr-1")
				|My Pages
		router-link(id="settings" v-if="d_perms.EAS" title="Settings" tag="button" class="btn btn-outline-primary btn-menu" :to="{path:'#settings'}") 
			fa-icon(icon="tools" class="mr-1")
			|Settings
		b-dropdown(variant="outline-primary" class="reminder" right lazy no-caret title="Reminders" toggle-class="btn-menu" )
			template(v-slot:button-content)
				fa-layers
					fa-icon(:icon="['far', 'bell']")
					fa-layers-text(class="kt-bbl" transform="up-12 right-15" :value="d_usrRmd.rmdCnt" v-if="d_usrRmd.rmdCnt")
			kt-reminders()
		b-dropdown(variant="outline-primary" title="My Profile" right lazy no-caret toggle-class="btn-menu"  ) 
			template(v-slot:button-content)
				fa-icon(icon="user-cog" class="mr-1")
				|Profile
			b-card(class="top-hdr-profile")
				template(v-slot:header)
					img(:src="c_profPicURL")
					span {{d_usrInf.teamMember.teamMemberName}}
				label Application User Name
				p {{d_usrInf.username}}
				b-button(class="chgpw" variant="link" @click="m_chgPwClick") Change Password
				label Email
				p {{d_usrInf.email}}
				label Authenticated On
				p {{d_usrInf.auth_time_str}}
				label(v-if="d_usrInf.teamMember.teamMemberNo") Team Member Record
				router-link(v-if="d_usrInf.teamMember" :to="c_teamRecordPath") {{d_usrInf.teamMember.teamMemberNo}}
				
				b-form-checkbox(switch class="py-2 show-rec-nums" v-model="d_showRecNums" @input="m_saveUserSetting") Show Record Numbers

		//- router-link(tag="button" class="btn btn-outline-primary" :to="{}")
		//- router-link(tag="button" class="btn btn-outline-primary" :to="{name:'LogOut'}") 
		b-button(variant="outline-primary" @click="m_logout" class="btn-menu" ) 
			fa-icon(icon="sign-out-alt" class="mr-1")
			|Log out
		
		//- Change PW
		b-modal(id="bm-top-hdr-chgpw" size="md" header-bg-variant="light"  hide-header-close centered 
			no-fade no-close-on-backdrop no-close-on-esc title="Change Password" @hidden="d_chgPW.clear()")
			div(class="form-group muted mb-3")
				label  Current Password
				b-form-input(id="change-pw-curr" size="sm" v-model="d_chgPW.curr"  type="password"  placeholder="Enter current password" 
				required :disabled="d_chgPW.loading" @focus="d_chgPW.error=null")
			div(class="form-group muted mb-1")
				label New Password
				b-form-input(id="change-pw-new1" size="sm" v-model="d_chgPW.new1"  type="password"  placeholder="Enter new password" class="my-2"
				required :disabled="d_chgPW.loading" :invalid="d_chgPW.new1!=d_chgPW.new2" @focus="d_chgPW.error=null")
				b-form-input(id="change-pw-new2" size="sm" v-model="d_chgPW.new2"  type="password"  placeholder="Reenter new password"
				required :disabled="d_chgPW.loading" :invalid="d_chgPW.new1!=d_chgPW.new2" @focus="d_chgPW.error=null")
			div(class="small pb-2 text-grey5" )
				span {{d_chgPW.pwstr}}
			div(class="error text-danger")
				span {{d_chgPW.error}}
			template(slot="modal-footer" slot-scope="{ ok, cancel, hide }")
				b-button(class="" variant="primary" @click="m_chgPwOk" :disabled="!(d_chgPW.curr && d_chgPW.new1 && d_chgPW.new2)")
					span(v-if="d_chgPW.loading" class="spinner-border spinner-border-sm mr-2" role="status")
					span Change Password
				b-button(variant="outline-secondary" @click="cancel()") Cancel
</template>

<script>

import {Help,userInfo, userSettings, userReminders} from "@/utils/ref-data.js";
import {fn_checkPageEnabled,fn_hrefVwRec, fn_profilePicURL, fn_saveUserOpts, kbdpAlert} from "@/utils/util.js";
import {lcl_userInfo,fn_appUserSession} from "@/utils/init.js";
import {fn_chgPw, pwStrTxt} from "@/views/LogIn.vue";
import KTMyPages from '@/components/Ctrl/KT-MyPagesComponent.vue'; 
export default {
	name: "top-hdr",
	components: {
		'kt-myPages':KTMyPages,
		'kt-reminders': () => import('@/components/Ctrl/KT-Reminders.vue'),
	},
	created() {
		let uo = userSettings.userOptions;
		this.d_showRecNums = uo.showRecordNumbers;
	},
	mounted() {},
	data() {
		return {
			d_usrInf: userInfo.getUserInfo(),
			d_perms: userSettings.permissions,
			d_showRecNums: false,
			d_usrRmd: userReminders,
			d_chgPW: {
				curr: null,
				new1: null,
				new2: null,
				error: null,
				loading: null,
				pwstr: pwStrTxt,
				clear: () => {
					let cp = this.d_chgPW;
					cp.curr = cp.new1 = cp.new2 = cp.error = null;
				}
			},
			d_componentKey:0,
			d_help:[...Help.filter(h=>h.active)],
		};
	},
	props: {},
	computed: {
		c_teamRecordPath() {
			let tm = this.d_usrInf.teamMember;
			if (!tm) return null;
			else return {path: fn_hrefVwRec('team', tm.teamMemberNo)};
		},
		c_profPicURL() {
			let tm = this.d_usrInf.teamMember;
			if (!tm) return null;
			return fn_profilePicURL(tm.teamMemberId);
		},

	},
	methods: {
		m_closeMyPagesDropdown(){this.$refs.myPagesDropdown.hide(true);},
		m_checkPage(page){return fn_checkPageEnabled(page);},
		m_saveUserSetting() {
			fn_saveUserOpts('showRecordNumbers', null, this.d_showRecNums);
		},
		m_chgPwClick(e) {
			if (e.detail > 1) return;
			this.d_chgPW.clear();
			this.$bvModal.show('bm-top-hdr-chgpw');
		},
		m_chgPwOk(e) {
			e.preventDefault();
			let cp = this.d_chgPW;
			cp.error = null;

			if (!cp.curr || !cp.new1 || !cp.new2) {
				return;
			}
			if (cp.new1 != cp.new2) {
				cp.error = 'The new passwords entered do not match.';
				return;
			}
			if (cp.curr == cp.new1 || cp.curr == cp.new2) {
				cp.error = 'Current and new passwords are the same.';
				return;
			}

			let fn_okCB = () => {
				kbdpAlert.showOk('Password Changed Successfully');
				this.$bvModal.hide('bm-top-hdr-chgpw');
				cp.loading = null;
			};
			cp.loading = true;

			fn_chgPw(cp, fn_okCB);

		},
		m_logout() {
			kbdpAlert.showLoading('Logging out');
			this.$router.push({name: 'LogOut'}, null, () => {});
		},
		m_redirect_email(){
				if(this.d_emailApp_window && !this.d_emailApp_window.closed) this.d_emailApp_window.focus();
				else{
					var emailURL='https://email.kiesetechnologies.com/?id='+lcl_userInfo.getUserInfo().teamMember.teamMemberId;
					this.d_emailApp_window=window.open(emailURL, 'emailApp','scrollbars=yes,resizable=yes,top=400,left=400,name=Email,width=1200, height=600'); 
					}
		
					return false;
			},
	},
	watch: {
	}
}
</script>

<style lang="less">
.top-hdr {
	.btn {
		font-size: 0.8em;
		margin-right: 0.3rem;
		padding: 0em 0.3em;
	}
	.dropdown-menu {
		padding: 0;
		//
	}

	.dropdown.reminder {
		// height: 21px;
		.btn {
			font-size: initial;
			line-height: 1em;

			.kt-bbl {
				background-color: #fd7e14;
			}
		}
		.dropdown-menu {
			width: 400px;
			max-width: 95vw;
			max-height: 90vh;
			overflow-y: auto;
		}
		.kt-reminders {
			padding: 0.4em;

			.reminder-header {
				padding: 0;
			}
		}
	}

	.top-hdr-profile {
		min-width: 250px;
		.card-header {
			background-color: unset;
			padding: 0.2em 0.5em;
			margin-bottom: 0.5em;
			img {
				border-radius: 1em;
				margin-right: 0.5em;
				height: 30px;
			}
			span {
				vertical-align: middle;
			}
		}
		.card-body {
			font-size: 0.9em;
			padding: 0em 1em;
			padding-bottom: 0.5em;
			> label {
				margin-bottom: 0;
				display: block;
			}
			> p {
				background-color: #e9ecef;
				padding: 0.2em 1em 0.2em 0.5em;
				border-color: #ced4da;
				margin-bottom: 0.5em;
			}
		}

		button.chgpw {
			padding: 0;
			margin: 0;
			line-height: 1em;
			margin-bottom: 0.5em;
			font-size: unset;
		}

		div.show-rec-nums {
			label {
				font-size: 0.95em;
				padding-top: 0.2em;
			}
		}
	}
}
#bm-top-hdr-chgpw {
	.modal-dialog {
		max-width: 350px;
	}
	.modal-header {
		padding: 0.2em 1em;
		.modal-title {
			font-size: 1em;
		}
	}
	.modal-body {
		.form-group {
			label {
				margin-bottom: 0;
			}
			width: 200px;

			input {
				&:invalid,
				&[invalid] {
					border-color: #dc3545;
					box-shadow: none;
				}
			}
		}
		.error {
			min-height: 24px;
		}
	}
	.modal-footer {
		justify-content: start;
		padding-top: 0;
	}
}
.btn-menu{border:none;}
.pageSetup1 {
			padding: 0.0em 0;
			max-height: 500px;
			min-width: 250px;
			overflow-y: scroll;
	}
hr {
    color: #ddd; 
    background-color: #ddd;
    height: 0.01px;
    border: none;
    max-width: 100%;
	margin-top: 0rem;
    margin-bottom: 0rem 
}
.myPages-dropdown {
        position: absolute;
        top: 0rem;
        right: 0rem;
        width: 250px;
        background-color: #fff;
        border: 1px solid #6c757d;
        border-radius: 8px;
        //transform: translate3d(-10px, 38px, 0px);
        will-change: transform;
        z-index: 20;
    }
.myPages-dropdown button:not(.filter-dropdown--close) {
        //width: 100%;
		font-weight: normal;
    }
.myPages-dropdown button {
        font-size: 14px;
        font-weight: bold;
        padding: 0.5rem 1rem;
        border: 0px;
        background-color: transparent;
    }
.myPages-dropdown button.btn-link {
        padding: 0.5rem;
        text-align: left;
    }
.myPages-dropdown .icon {
        width: 1rem;
        margin-right: 0.5rem;
    }
.myPages-dropdown .expand {
        background-color: rgb(245, 245, 245);
        padding: 1.25rem;
    }
</style>